import axios from "axios";  
import { BASE_URL } from "../../assets/constants";
import { createFormHeaders, createHeaders } from "../../utils/Utils";

//! Result APIs
//TODO: Immunity APIs
//  Immunity Result Fetch
export const getImmunityResults = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}get-immunity-results`, data,headers);
};
//  Immunity Result By Id
export const getImmunityResultById = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}get-immunity-result-by-id`, data,headers);
};
//TODO: Prakrity APIs
//  Prakrity Result Fetch
export const getPrakrityResults = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}get-prakrity-results`, data,headers);
};
//  Prakrity Result By Id
export const getPrakrityResultById = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}get-prakrity-result-by-id`, data,headers);
};